// extracted by mini-css-extract-plugin
export var headingStyle = "rsc_hb_section_inner-module--headingStyle--R0NfU";
export var sectionWrapperStyle = "rsc_hb_section_inner-module--sectionWrapperStyle--iFD+m";